import {
  ProductStatus,
  productVersionToFirestore,
} from '@parallel-fluidics/shared/models/products';
import {
  doc,
  getFirestore,
  runTransaction,
  serverTimestamp,
} from 'firebase/firestore';

import promoteActiveVersion from './_promoteActiveVersion';

export default async function createProductVersion({
  productDocId,
  versionId,
  versionData,
  activateNow = false,
  createdBy,
}) {
  const db = getFirestore();
  const productRef = doc(db, 'products', productDocId);
  const versionRef = doc(db, 'products', productDocId, 'versions', versionId);

  await runTransaction(db, async (transaction) => {
    const [productSnapshot, versionSnapshot] = await Promise.all([
      transaction.get(productRef),
      transaction.get(versionRef),
    ]);

    if (!productSnapshot.exists()) throw new Error(`Product not found: ${productDocId}`);
    if (versionSnapshot.exists()) throw new Error(`Version already exists: ${versionId}`);

    const currentActiveId = productSnapshot.data().activeVersionId;

    const payload = {
      ...versionData,
      status: activateNow ? ProductStatus.ACTIVE : ProductStatus.DRAFT,
      projectDocId: versionData.projectDocId || null,
      pPartDocId: versionData.pPartDocId || null,
      leadtimeDays: versionData.leadtimeDays ?? null,
      previewGlb: versionData.previewGlb || null,
      reorderPolicy: versionData.reorderPolicy || null,
      createdBy,
    };

    // Build the Firestore doc and inject effectiveAt when activating,
    // so the version is written in a single operation.
    const versionDoc = productVersionToFirestore(payload, serverTimestamp);
    if (versionDoc.reorderPolicy) {
      versionDoc.reorderPolicy.updatedAt = serverTimestamp();
    }
    if (activateNow) {
      versionDoc.effectiveAt = serverTimestamp();
    }
    transaction.set(versionRef, versionDoc);

    if (!activateNow) return;

    promoteActiveVersion(transaction, {
      db,
      productDocId,
      versionId,
      currentActiveId,
      serverTimestamp,
    });
  });
}
